/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "ignorePropertyModificationsFor": ["state"] }] */
// initial state
const state = () => ({
  actualStep: 1,
  nbStep: 0,
});

// getters
const getters = {
  actualStep: (state) => state.actualStep,
  nbStep: (state) => state.nbStep,
};

// actions
const actions = {
  changeActuelStep({ commit }, step) {
    commit('setActualStep', step);
  },
  changeNbStep({ commit }, nbStep) {
    commit('setNbStep', nbStep);
  },
};

// mutations
const mutations = {
  setActualStep(state, step) {
    state.actualStep = step;
  },
  setNbStep(state, nbStep) {
    state.nbStep = nbStep;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
